import { render } from "./UpdatePrice.vue?vue&type=template&id=ce923404&scoped=true"
import script from "./UpdatePrice.vue?vue&type=script&lang=js"
export * from "./UpdatePrice.vue?vue&type=script&lang=js"

import "./UpdatePrice.vue?vue&type=style&index=0&id=ce923404&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce923404"]])

export default __exports__